import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class RolesService {
	baseUrl: string;
	constructor(private _http: HttpClient) {
		this.baseUrl = environment.API_SERVER;
	}

	getRoles(payload) {
		return this._http.get(this.baseUrl + '/admin/roles/', { params: payload.params });
	}
	getRolePermission(payload) {
		return this._http.get(
			`${this
				.baseUrl}/organizations/${payload.organizationId}/users/${payload.appUserId}/permissions/aggregate/roles/${payload.roleName}/permissions/`
		);
	}
	addRoles(payload) {
		return this._http.post(this.baseUrl + '/admin/roles/', payload.body);
	}
	deleteRole(payload) {
		return this._http.delete(`${this.baseUrl}/organizations/${payload.organizationId}/roles/${payload.roleName}/`);
	}

	updateRoles(payload) {
		return this._http.put(`${this.baseUrl}/admin/roles/${payload.roleId}/`, payload.body);
	}
	assignRolePermission(payload) {
		return this._http.put(
			`${this.baseUrl}/organizations/${payload.organizationId}/roles/${payload.roleName}/permissions/`,
			payload.body
		);
	}

	deleteRoles(payload) {
		return this._http.delete(`${this.baseUrl}/admin/roles/${payload.roleId}/`);
	}
}
